import { Seo } from '@/components/Seo';
import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <>
      <Seo title="Page Not Found — ai-free-resume" description="The page you requested was not found." path="/404" noindex />
      <section className="flex min-h-[60vh] items-center justify-center bg-[#F0F3F5] px-6">
        <div className="text-center">
          <h1 className="text-6xl font-bold text-[#0F4C81]">404</h1>
          <p className="mt-4 text-2xl font-semibold text-[#1A202C]">Page not found</p>
          <p className="mt-2 text-[#4A5568]">
            The page you are looking for does not exist or has been moved.
          </p>
          <Link
            to="/"
            className="mt-8 inline-flex items-center justify-center rounded-lg bg-[#0F4C81] px-7 py-3.5 text-base font-semibold text-white hover:bg-[#083D6E]"
          >
            Go Home
          </Link>
        </div>
      </section>
    </>
  );
}

export default NotFound;
